import Wrapper from './wrapper';

export default Wrapper;
